import "./Navbar.scss";
import zLogo from "../../assets/images/ZunigaLogo.svg";
import { Link } from "react-router-dom";
import hamburger from "../../assets/icons/menu.svg";
import close from "../../assets/icons/menuClose.svg";
import { useState } from "react";

export default function Navbar() {
  const [isNavOpen, setIsNavOpen] = useState<boolean>(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  const setScroll = () => {
    if (window.scrollY >= 80) {
      setHasScrolled(true);
    } else {
      setHasScrolled(false);
    }
  };

  window.addEventListener("scroll", setScroll);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const closeNav = () => {
    setIsNavOpen(false);
  };

  return (
    <div
      className={`navbar 
  ${isNavOpen ? "navbar--active" : ""} 
  ${hasScrolled ? "navbar--scroll navbar--scrollMobile" : ""}`}
    >
      <Link to="/" className="navbar__logo" onClick={closeNav}>
        <img src={zLogo} alt="Zuniga Logo" className="navbar__img" />
      </Link>
      <button className="navbar__hamburger" onClick={toggleNav}>
        <img
          src={isNavOpen ? close : hamburger}
          alt={isNavOpen ? "Close menu button" : "Open menu button"}
        />
      </button>
      <ul className={`navbar__list ${isNavOpen ? "navbar__list--active" : ""}`}>
        <li className="navbar__item">
          <Link to="/" className="navbar__link" onClick={closeNav}>
            Home
          </Link>
        </li>
        <li className="navbar__item">
          <Link to="/projects" className="navbar__link" onClick={closeNav}>
            Projects
          </Link>
        </li>
        <li className="navbar__item">
          <Link to="/services" className="navbar__link" onClick={closeNav}>
            Services
          </Link>
        </li>
        <li className="navbar__item">
          <a href="#contact" className="navbar__link" onClick={closeNav}>
            Contact
          </a>
        </li>
        <li className="navbar__item">
          <a
            href="/ZunigaResume.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="navbar__link"
            onClick={closeNav}
          >
            Resume
          </a>
        </li>
      </ul>
    </div>
  );
}
